import React from "react";
import { Link } from "react-router-dom";
import Shared from "../../../../components/ReUseAbleComponents/Shared";

function KnowledgeBase(props) {
  return (
    <>
      <Shared />
      <div className="dx-box-5 pb-100 bg-grey-6">
        <div className="container">
          <div className="row vertical-gap md-gap">
            <div className="col-lg-8">
              <div className="dx-box dx-box-decorated">
                <div className="dx-blog-post">
                  <div className="dx-blog-post-box pt-30 pb-30">
                    <h2 className="h4 mnt-5 mb-8">Browse Article Categories</h2>

                    <ul className="dx-breadcrumbs text-left dx-breadcrumbs-dark mnb-8">
                      <li>
                        <Link to="/help-center">Support Home</Link>
                      </li>
                      <li>Articles</li>
                    </ul>
                  </div>
                  <div className="dx-separator"></div>
                  <div className="dx-blog-post-box">
                    <div className="row vertical-gap lg-gap">
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Quantial</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Make menu dropdown working without JavaScript
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">Google Analytics</Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                How to manually import Demo data (if you faced
                                with problems in one-click demo import)
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            4 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Sensific</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">Google Analytics</Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                How to manually import Demo data (if you faced
                                with problems in one-click demo import)
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Make menu dropdown working witho
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            4 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Minist</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                WordPress Themes FAQ
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Change navbar background color
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Change images and banners overlay color
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            8 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Desty</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Make menu dropdown working without JavaScript
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Google Map API Warning (NoApiKeys)
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            2 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Silies</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Add top menu link inside dropdown on mobile
                                devices
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Google Map API Warning (NoApiKeys)
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Make dropdown items links working
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            3 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Interra</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                WordPress Themes FAQ
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Make menu dropdown working without JavaScript
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">Google Analytics</Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            3 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Explora</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Google Map API Warning (NoApiKeys)
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Make menu dropdown working without JavaScript
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            2 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Thoute</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Make menu dropdown working without JavaScript
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                Google Map API Warning (NoApiKeys)
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            2 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Accountry</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">Google Analytics</Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                How to open image by click on slider
                              </Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                WordPress Themes FAQ
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            3 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Mained</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">Google Analytics</Link>
                            </li>
                            <li>
                              <Link to="/single-article">
                                WordPress Themes FAQ
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            2 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Treate</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Google Map API Warning (NoApiKeys)
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            1 Articles
                          </Link>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="dx-article dx-article-list">
                          <h3 className="h6 dx-article-title">Priety</h3>
                          <ul className="dx-list">
                            <li>
                              <Link to="/single-article">
                                Google Map API Warning (NoApiKeys)
                              </Link>
                            </li>
                          </ul>
                          <Link
                            to="/single-article-category"
                            className="dx-btn dx-btn-xs dx-btn-grey-1 dx-article-btn"
                          >
                            1 Articles
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="dx-sticky dx-sidebar"
                data-sticky-offsetTop="120"
                data-sticky-offsetBot="40"
              >
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">
                    {" "}
                    Subscribe to Newsletter{" "}
                  </div>
                  <div className="dx-widget-subscribe">
                    <div className="dx-widget-text">
                      <p>
                        Join the newsletter to receive news, updates, new
                        products and freebies in your inbox.
                      </p>
                    </div>
                    <form action="#" className="dx-form dx-form-group-inputs">
                      <input
                        type="email"
                        name=""
                        value=""
                        aria-describedby="emailHelp"
                        className="form-control form-control-style-2"
                        placeholder="Your Email Address"
                      />
                      <button className="dx-btn dx-btn-lg dx-btn-icon">
                        <span className="icon fas fa-paper-plane"></span>
                      </button>
                    </form>
                  </div>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <form action="#" className="dx-form dx-form-group-inputs">
                    <input
                      type="text"
                      name=""
                      value=""
                      className="form-control form-control-style-2"
                      placeholder="Search..."
                    />
                    <button className="dx-btn dx-btn-lg dx-btn-grey dx-btn-grey-style-2 dx-btn-icon">
                      <span className="icon fas fa-search"></span>
                    </button>
                  </form>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title">Articles Categories</div>
                  <ul className="dx-widget-categories">
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Quantial
                        </span>
                        <span className="dx-widget-categories-badge">(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Sensific
                        </span>
                        <span className="dx-widget-categories-badge">(4)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Minist
                        </span>
                        <span className="dx-widget-categories-badge">(8)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Desty
                        </span>
                        <span className="dx-widget-categories-badge">(2)</span>
                      </Link>
                    </li>
                    <li>
                      <Link to="/single-article">
                        <span className="icon pe-7s-angle-right"></span>
                        <span className="dx-widget-categories-category">
                          Silies
                        </span>
                        <span className="dx-widget-categories-badge">(3)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Articles </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      How to manually import Demo data (if you faced with
                      problems in one-click demo import)
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Make menu dropdown working without JavaScript
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Add top menu link inside dropdown on mobile devices
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
                <div className="dx-widget dx-box dx-box-decorated">
                  <div className="dx-widget-title"> Latest Forum Topics </div>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Need help with customization. Some options are not
                      appearing...
                    </span>
                    <span className="dx-widget-link-date">6 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      My images on profile and item pages doesnt show up?! Whats
                      the matter?
                    </span>
                    <span className="dx-widget-link-date">2 Sep 2018</span>
                  </Link>
                  <Link to="/single-article" className="dx-widget-link">
                    <span className="dx-widget-link-text">
                      Theme not updating in downloads
                    </span>
                    <span className="dx-widget-link-date">27 Aug 2018</span>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default KnowledgeBase;
